import { render, staticRenderFns } from "./CbsRecordForm.vue?vue&type=template&id=384afcba&scoped=true"
import script from "./CbsRecordForm.vue?vue&type=script&lang=js"
export * from "./CbsRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384afcba",
  null
  
)

export default component.exports